import { render, screen } from '@testing-library/react'
import MenstrualCultureDefinition from './MenstrualCultureDefinition'

test('shows the complete definition without a disclosure control', () => {
  render(<MenstrualCultureDefinition />)

  expect(screen.getByRole('heading', { name: 'Cultura Menstrual / Definición' })).toBeTruthy()
  expect(screen.queryByRole('button')).toBeNull()
  expect(screen.getByText(/La cultura, según la UNESCO/)).toBeTruthy()
  expect(screen.getByText(/Extracto de la conceptualización elaborada por Carolina Ackermann Barreiro/)).toBeTruthy()
})
